import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  constructor(private http: HttpClient) {}

  //
  /*

  download
  {{BASE_URL_COMMON_API}}/v1/employer/reports/from-user/:id/file

  distinzione xlsx da csv e pdf
  */

  getReports(id: number): Observable<any> {
    return this.http.get(
      environment.baseUrlWs +
        environment.wsVerison +
        "employer/reports/from-user/" +
        id
    );
  }

  downloadFile(id: number): Observable<any> {
    return this.http.get(
      environment.baseUrlWs +
        environment.wsVerison +
        "employer/reports/from-user/" +
        id +
        "/file",
      { observe: "response", responseType: "arraybuffer" as "json" }
    );
  }
}
